// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Card,
//   Avatar,
//   Pagination,
//   IconButton,
//   Skeleton,
//   Tabs,
//   Tab,
//   Icon,
//   Box,
// } from "@mui/material";

// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";

// import SoftBox from "components/SoftBox";
// import SoftTypography from "components/SoftTypography";

// import { teamLeaveSummary } from "api/users";

// import LeaveSummaryTab from "../leaveSummaryTab";
// import LeavaBalance from "../LeaveBalance";
// import MyLeaveRequest from "../myRequest";

// import { useDropdownOptions } from "layouts/interviewSelected/hooks/useDropdownOptions";
// import UserFilters from "layouts/interviewSelected/components/useFilters";
// import { ArrowBack, Person } from "@mui/icons-material";

// const LeaveTeamList = () => {
//   const [teamList, setTeamList] = useState([]);

//   const [pageLoading, setPageLoading] = useState(true);
//   const [listLoading, setListLoading] = useState(false);

//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);

//   const [selectedUser, setSelectedUser] = useState(null);
//   const [activeDataTab, setActiveDataTab] = useState("Leave Summary");

//   const [filters, setFilters] = useState({
//     branch_id: "",
//     shift_id: "",
//     department_id: "",
//     designation_id: "",
//     role: "",
//   });

//   const [searchTerm, setSearchTerm] = useState("");

//   const { dropdownOptions, fetchShiftsForBranch } = useDropdownOptions();

//   // -------------------------
//   // FETCH TEAM LIST
//   // -------------------------
//   const fetchTeamList = useCallback(
//     async (currentPage = 1, isInitial = false) => {
//       try {
//         isInitial ? setPageLoading(true) : setListLoading(true);

//         const params = {
//           page: currentPage,
//           ...filters,
//           q: searchTerm,
//         };

//         Object.keys(params).forEach((k) => {
//           if (!params[k]) delete params[k];
//         });

//         const response = await teamLeaveSummary(params);

//         setTeamList(response?.data?.data || []);
//         setTotalPages(response?.data?.last_page || 1);
//       } catch (err) {
//         console.error("Error loading team data:", err);
//         setTeamList([]);
//       } finally {
//         setPageLoading(false);
//         setListLoading(false);
//       }
//     },
//     [filters, searchTerm]
//   );

//   useEffect(() => {
//     fetchTeamList(page, true);
//   }, []);

//   useEffect(() => {
//     fetchTeamList(page, false);
//   }, [page, filters, searchTerm]);

//   const handleFilterChange = (key, value) => {
//     setFilters((prev) => ({ ...prev, [key]: value }));
//     setPage(1);
//   };

//   // -------------------------
//   // SKELETON CARD
//   // -------------------------
//   const SkeletonCard = (
//     <Card sx={{ p: 2, borderRadius: 3, height: "100%" }}>
//       <Skeleton variant="circular" width={50} height={50} />
//       <Skeleton sx={{ mt: 2 }} height={20} width="60%" />
//       <Skeleton height={15} width="40%" />
//     </Card>
//   );

//   // -------------------------
//   // PAGE LOADER
//   // -------------------------
//   if (pageLoading) {
//     return (
//       <SoftBox p={3}>
//         <Row className="g-4">
//           {Array.from({ length: 8 }).map((_, i) => (
//             <Col key={i} xs={12} sm={6} md={3}>
//               {SkeletonCard}
//             </Col>
//           ))}
//         </Row>
//       </SoftBox>
//     );
//   }

//   const getDayTypeColor = (day_type) => {
//     switch (day_type) {
//       case "holiday":
//         return "#e8f5e9"; // Light green
//       case "weekend":
//         return "#e3f2fd"; // Light blue
//       case "leave":
//         return "#fff3e0"; // Light orange
//       case "working_day":
//         return "#f5f5f5"; // Light gray
//       default:
//         return "#ffffff";
//     }
//   };

//   return (
//     <SoftBox sx={{ position: "relative", pb: "80px" }}>
//       {!selectedUser ? (
//         <Card>
//           <SoftBox px={3} py={1}>
//             {/* 🔹 FILTERS INSIDE CARD */}
//             <UserFilters
//               filters={filters}
//               onFilterChange={handleFilterChange}
//               searchTerm={searchTerm}
//               onSearchChange={setSearchTerm}
//               dropdownOptions={dropdownOptions}
//               fetchShiftsForBranch={fetchShiftsForBranch}
//             />

//             {/* 🔹 TEAM CARDS */}
//             {/* <SoftBox mt={1.5}>
//               <Row className="g-4">
//                 {listLoading
//                   ? Array.from({ length: 8 }).map((_, i) => (
//                       <Col key={i} xs={12} sm={6} md={3}>
//                         {SkeletonCard}
//                       </Col>
//                     ))
//                   : teamList.map((user) => (
//                       <Col key={user.id} xs={12} sm={6} md={3}>
//                         <Card
//                           onClick={() => {
//                             setSelectedUser(user);
//                             setActiveDataTab("Leave Summary");
//                           }}
//                           sx={{
//                             px: 1,
//                             pt: 1,
//                             borderRadius: 3,
//                             height: "100%",
//                             cursor: "pointer",
//                             border: "1px solid #e7e7e7",
//                             background: "#f5f5f5",
//                             transition: "all 0.35s ease",
//                             "&:hover": {
//                               transform: "translateY(-6px) scale(1.02)",
//                               boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
//                             },
//                           }}
//                         >
//                           <SoftBox display="flex" alignItems="center" mb={0.5}>
//                             <Avatar
//                               src={user.photo || ""}
//                               sx={{
//                                 width: 35,
//                                 height: 35,
//                                 bgcolor: "#3f51b5",
//                                 color: "white",
//                                 mr: 1.5,
//                                 fontSize: "1rem",
//                               }}
//                             >
//                               {!user.photo &&
//                                 user.name
//                                   ?.split(" ")
//                                   .map((n) => n[0])
//                                   .join("")
//                                   .slice(0, 2)
//                                   .toUpperCase()}
//                             </Avatar>

//                             <SoftBox>
//                               <SoftTypography
//                                 variant="h6"
//                                 fontWeight="bold"
//                                 sx={{
//                                   fontSize: "0.9rem",
//                                   whiteSpace: "nowrap",
//                                   overflow: "hidden",
//                                   textOverflow: "ellipsis",
//                                 }}
//                               >
//                                 {user.name}
//                               </SoftTypography>
//                             </SoftBox>
//                           </SoftBox>

//                           <SoftBox
//                             sx={{
//                               background:
//                                 user.approved_leave_days_this_year === 0
//                                   ? "#ffebee" // light red
//                                   : "#e8f5e9", // light green
//                               p: 0.1,
//                               borderRadius: 2,
//                               mb: 1,
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               gap: 0.5,
//                             }}
//                           >
//                             <Icon
//                               sx={{
//                                 fontSize: "1rem",
//                                 color:
//                                   user.approved_leave_days_this_year === 0
//                                     ? "#f44336" // red
//                                     : "#4caf50", // green
//                               }}
//                             >
//                               {user.approved_leave_days_this_year === 0 ? "cancel" : "check_circle"}
//                             </Icon>

//                             <SoftTypography
//                               variant="button"
//                               fontWeight="medium"
//                               sx={{
//                                 fontSize: "0.75rem",
//                                 color:
//                                   user.approved_leave_days_this_year === 0 ? "#f44336" : "#4caf50",
//                               }}
//                             >
//                               {user.approved_leave_days_this_year} Days Used
//                             </SoftTypography>
//                           </SoftBox>

//                           {user.shift && (
//                             <SoftTypography variant="caption">
//                               Shift: {user.shift.start_time} - {user.shift.end_time}
//                             </SoftTypography>
//                           )}
//                         </Card>
//                       </Col>
//                     ))}
//               </Row>
//             </SoftBox> */}

//             <SoftBox my={1}>
//               {/* 🔹 NO USER FOUND */}
//               {!listLoading && teamList.length === 0 ? (
//                 <SoftBox textAlign="center" py={5}>
//                   <Icon sx={{ fontSize: 60, color: "#ccc", mb: 2 }}>sentiment_dissatisfied</Icon>
//                   <SoftTypography variant="h6" color="textSecondary">
//                     No users found
//                   </SoftTypography>
//                 </SoftBox>
//               ) : (
//                 <Row className="g-2">
//                   {listLoading
//                     ? Array.from({ length: 8 }).map((_, i) => (
//                       <Col key={i} xs={12} sm={6} md={3}>
//                         {SkeletonCard}
//                       </Col>
//                     ))
//                     : teamList.map((user) => (
//                       <Col key={user.id} xs={12} sm={6} md={3}>
//                         <Card
//                           onClick={() => {
//                             setSelectedUser(user);
//                             setActiveDataTab("Leave Summary");
//                           }}
//                           sx={{
//                             px: 1,
//                             pt: 1,
//                             borderRadius: 3,
//                             height: "100%",
//                             cursor: "pointer",
//                             border: "1px solid #e7e7e7",
//                             background: "#f5f5f5",
//                             transition: "all 0.35s ease",
//                             "&:hover": {
//                               transform: "translateY(-6px) scale(1.02)",
//                               boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
//                             },
//                           }}
//                         >
//                           {/* 🔹 USER HEADER */}
//                           <SoftBox display="flex" alignItems="center" mb={0.5}>
//                             <Avatar
//                               src={user.photo || ""}
//                               sx={{
//                                 width: 35,
//                                 height: 35,
//                                 bgcolor: "#3f51b5",
//                                 color: "white",
//                                 mr: 1.5,
//                                 fontSize: "1rem",
//                               }}
//                             >
//                               {!user.photo &&
//                                 user.name
//                                   ?.split(" ")
//                                   .map((n) => n[0])
//                                   .join("")
//                                   .slice(0, 2)
//                                   .toUpperCase()}
//                             </Avatar>

//                             <SoftBox>
//                               <SoftTypography
//                                 variant="h6"
//                                 fontWeight="bold"
//                                 sx={{
//                                   fontSize: "0.9rem",
//                                   whiteSpace: "nowrap",
//                                   overflow: "hidden",
//                                   textOverflow: "ellipsis",
//                                 }}
//                               >
//                                 {user.name}
//                               </SoftTypography>
//                             </SoftBox>
//                           </SoftBox>

//                           {/* 🔹 STATUS BADGE */}
//                           <SoftBox
//                             sx={{
//                               background:
//                                 user.approved_leave_days_this_year === 0 ? "#ffebee" : "#e8f5e9",
//                               p: 0.1,
//                               borderRadius: 2,
//                               mb: 1,
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               gap: 0.5,
//                             }}
//                           >
//                             <Icon
//                               sx={{
//                                 fontSize: "1rem",
//                                 color:
//                                   user.approved_leave_days_this_year === 0
//                                     ? "#f44336"
//                                     : "#4caf50",
//                               }}
//                             >
//                               {user.approved_leave_days_this_year === 0
//                                 ? "cancel"
//                                 : "check_circle"}
//                             </Icon>

//                             <SoftTypography
//                               variant="button"
//                               fontWeight="medium"
//                               sx={{
//                                 fontSize: "0.75rem",
//                                 color:
//                                   user.approved_leave_days_this_year === 0
//                                     ? "#f44336"
//                                     : "#4caf50",
//                               }}
//                             >
//                               {user.approved_leave_days_this_year} Days Used
//                             </SoftTypography>
//                           </SoftBox>

//                           {/* 🔹 SHIFT INFO */}
//                           {user.shift && (
//                             <SoftTypography variant="caption">
//                               Shift: {user.shift.start_time} - {user.shift.end_time}
//                             </SoftTypography>
//                           )}
//                         </Card>
//                       </Col>
//                     ))}
//                 </Row>
//               )}
//             </SoftBox>
//           </SoftBox>

//           {/* 🔹 PAGINATION */}
//           <SoftBox
//             sx={{
//               position: "fixed",
//               width: "90%",
//               bottom: 0,
//               background: "#fff",
//               pt: 1,
//               zIndex: 20,
//               borderTop: "1px solid #e0e0e0",
//               display: "flex",
//               justifyContent: "center",
//             }}
//           >
//             <Pagination count={totalPages} page={page} onChange={(_, value) => setPage(value)} />
//           </SoftBox>
//         </Card>
//       ) : (
//         <>
//           {/* 🔹 BACK HEADER */}
//           <SoftBox display="flex" alignItems="center" mt={-1.5} mb={0} gap={1.5}>
//             {/* <IconButton onClick={() => setSelectedUser(null)}>
//               <Icon>arrow_back</Icon>
//             </IconButton>
//             <SoftTypography variant="h6" fontWeight="bold" color="text">
//               {selectedUser.name}’s Leave Details
//             </SoftTypography> */}
//             {/* Back Button */}
//             <IconButton onClick={() => setSelectedUser(null)} size="small">
//               <ArrowBack fontSize="small" />
//             </IconButton>

//             {/* Profile Icon */}
//             <Box
//               sx={{
//                 width: 36,
//                 height: 36,
//                 borderRadius: "50%",
//                 bgcolor: "#EEF2FF",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 border: "1px solid #E0E7FF",
//               }}
//             >
//               <Person sx={{ fontSize: 18 }} />
//             </Box>

//             {/* User Name */}
//             <SoftTypography variant="h6" color="text">
//               {selectedUser?.name}
//             </SoftTypography>
//           </SoftBox>

//           {/* 🔹 TABS */}
//           <Tabs value={activeDataTab} onChange={(_, v) => setActiveDataTab(v)}>
//             {["Leave Summary", "Leave Balance", "My Request"].map((tab) => (
//               <Tab
//                 key={tab}
//                 value={tab}
//                 label={
//                   <SoftTypography fontSize="0.875rem" fontWeight="medium" color="text">
//                     {tab}
//                   </SoftTypography>
//                 }
//               />
//             ))}
//           </Tabs>

//           {/* 🔹 TAB CONTENT */}
//           {activeDataTab === "Leave Summary" && (
//             <Box sx={{ mt: 2 }} mt={2}>
//               <LeaveSummaryTab userId={selectedUser.id} />
//             </Box>
//           )}
//           {activeDataTab === "Leave Balance" && (
//             <Box sx={{ mt: 1.5 }}>
//               <LeavaBalance userId={selectedUser.id} />
//             </Box>
//           )}
//           {activeDataTab === "My Request" && (
//             <Box sx={{ mt: 1.5 }}>
//               <MyLeaveRequest userId={selectedUser.id} />
//             </Box>
//           )}
//         </>
//       )}
//     </SoftBox>
//   );
// };

// export default LeaveTeamList;


import React, { useState, useEffect, useCallback } from "react";
import {
  Card,
  Avatar,
  Pagination,
  IconButton,
  Skeleton,
  Tabs,
  Tab,
  Icon,
  Box,
} from "@mui/material";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftPagination from "components/SoftPagination";

import { teamLeaveSummary } from "api/users";

import LeaveSummaryTab from "../leaveSummaryTab";
import LeavaBalance from "../LeaveBalance";
import MyLeaveRequest from "../myRequest";

// ✅ NEW hook
import { useDropdownOptions } from "layouts/interviewSelected/hooks/useDropdownOptions";
import UserFilters from "layouts/interviewSelected/components/useFilters";
import { ArrowBack, Person } from "@mui/icons-material";

const LeaveTeamList = () => {
  const [teamList, setTeamList] = useState([]);

  const [pageLoading, setPageLoading] = useState(true);
  const [listLoading, setListLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [selectedUser, setSelectedUser] = useState(null);
  const [activeDataTab, setActiveDataTab] = useState("Leave Summary");

  const [filters, setFilters] = useState({
    branch_id: "",
    shift_id: "",
    department_id: "",
    designation_id: "",
    role: "",
  });

  const [searchTerm, setSearchTerm] = useState("");

  // ✅ NEW – useDropdownOptions returns lazy‑loaded options and fetch functions
  const {
    options: dropdownOptions,
    loading: dropdownLoading,
    fetchBranches,
    fetchSubBranches,
    fetchShifts,
    fetchDepartments,
    fetchDesignations,
    fetchRoles,
  } = useDropdownOptions();

  // -------------------------
  // FETCH TEAM LIST
  // -------------------------
  const fetchTeamList = useCallback(
    async (currentPage = 1, isInitial = false) => {
      try {
        isInitial ? setPageLoading(true) : setListLoading(true);

        const params = {
          page: currentPage,
          ...filters,
          q: searchTerm,
        };

        Object.keys(params).forEach((k) => {
          if (!params[k]) delete params[k];
        });

        const response = await teamLeaveSummary(params);

        setTeamList(response?.data?.data || []);
        setTotalPages(response?.data?.last_page || 1);
      } catch (err) {
        console.error("Error loading team data:", err);
        setTeamList([]);
      } finally {
        setPageLoading(false);
        setListLoading(false);
      }
    },
    [filters, searchTerm]
  );

  useEffect(() => {
    fetchTeamList(page, true);
  }, []);

  useEffect(() => {
    fetchTeamList(page, false);
  }, [page, filters, searchTerm]);

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
    setPage(1);
  };

  // -------------------------
  // SKELETON CARD
  // -------------------------
  const SkeletonCard = (
    <Card sx={{ p: 2, borderRadius: 3, height: "100%" }}>
      <Skeleton variant="circular" width={50} height={50} />
      <Skeleton sx={{ mt: 2 }} height={20} width="60%" />
      <Skeleton height={15} width="40%" />
    </Card>
  );

  // -------------------------
  // PAGE LOADER
  // -------------------------
  if (pageLoading) {
    return (
      <SoftBox p={3}>
        <Row className="g-4">
          {Array.from({ length: 8 }).map((_, i) => (
            <Col key={i} xs={12} sm={6} md={3}>
              {SkeletonCard}
            </Col>
          ))}
        </Row>
      </SoftBox>
    );
  }

  const getDayTypeColor = (day_type) => {
    switch (day_type) {
      case "holiday":
        return "#e8f5e9"; // Light green
      case "weekend":
        return "#e3f2fd"; // Light blue
      case "leave":
        return "#fff3e0"; // Light orange
      case "working_day":
        return "#f5f5f5"; // Light gray
      default:
        return "#ffffff";
    }
  };

  const getPaginationRange = () => {
    const total = totalPages;
    const current = page;
    const limit = 5;

    let start = Math.max(1, current - Math.floor(limit / 2));
    let end = start + limit - 1;

    if (end > total) {
      end = total;
      start = Math.max(1, end - limit + 1);
    }

    const pages = [];

    if (start > 1) {
      pages.push(1);
      if (start > 2) pages.push("...");
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < total) {
      if (end < total - 1) pages.push("...");
      pages.push(total);
    }

    return pages;
  };

  return (
    <SoftBox sx={{ position: "relative", pb: "80px" }}>
      {!selectedUser ? (
        <Card>
          <SoftBox px={3} py={1}>
            {/* ✅ UPDATED FILTERS – with new props */}
            <UserFilters
              filters={filters}
              onFilterChange={handleFilterChange}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
              dropdownOptions={dropdownOptions}
              loading={dropdownLoading}
              fetchBranches={fetchBranches}
              fetchSubBranches={fetchSubBranches}
              fetchShifts={fetchShifts}
              fetchDepartments={fetchDepartments}
              fetchDesignations={fetchDesignations}
              fetchRoles={fetchRoles}
              pageContext="LeaveTracker.Team"
            // showHistoryFilters is false by default, no need to pass
            />

            <SoftBox my={1}>
              {!listLoading && teamList.length === 0 ? (
                <SoftBox textAlign="center" py={5}>
                  <Icon sx={{ fontSize: 60, color: "#ccc", mb: 2 }}>sentiment_dissatisfied</Icon>
                  <SoftTypography variant="h6" color="textSecondary">
                    No users found
                  </SoftTypography>
                </SoftBox>
              ) : (
                <Row className="g-2">
                  {listLoading
                    ? Array.from({ length: 8 }).map((_, i) => (
                      <Col key={i} xs={12} sm={6} md={3}>
                        {SkeletonCard}
                      </Col>
                    ))
                    : teamList.map((user) => (
                      <Col key={user.id} xs={12} sm={6} md={3}>
                        <Card
                          onClick={() => {
                            setSelectedUser(user);
                            setActiveDataTab("Leave Summary");
                          }}
                          sx={{
                            px: 1,
                            pt: 1,
                            borderRadius: 3,
                            height: "100%",
                            cursor: "pointer",
                            border: "1px solid #e7e7e7",
                            background: "#f5f5f5",
                            transition: "all 0.35s ease",
                            "&:hover": {
                              transform: "translateY(-6px) scale(1.02)",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                            },
                          }}
                        >
                          <SoftBox display="flex" alignItems="center" mb={0.5}>
                            <Avatar
                              src={user.photo || ""}
                              sx={{
                                width: 35,
                                height: 35,
                                bgcolor: "#3f51b5",
                                color: "white",
                                mr: 1.5,
                                fontSize: "1rem",
                              }}
                            >
                              {!user.photo &&
                                user.name
                                  ?.split(" ")
                                  .map((n) => n[0])
                                  .join("")
                                  .slice(0, 2)
                                  .toUpperCase()}
                            </Avatar>
                            <SoftBox>
                              <SoftTypography
                                variant="h6"
                                fontWeight="bold"
                                sx={{
                                  fontSize: "0.9rem",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {user.name} {user.last_name}
                              </SoftTypography>
                            </SoftBox>
                          </SoftBox>

                          <SoftBox
                            sx={{
                              background:
                                user.approved_leave_days_this_year === 0 ? "#ffebee" : "#e8f5e9",
                              p: 0.1,
                              borderRadius: 2,
                              mb: 1,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 0.5,
                            }}
                          >
                            <Icon
                              sx={{
                                fontSize: "1rem",
                                color:
                                  user.approved_leave_days_this_year === 0
                                    ? "#f44336"
                                    : "#4caf50",
                              }}
                            >
                              {user.approved_leave_days_this_year === 0
                                ? "cancel"
                                : "check_circle"}
                            </Icon>
                            <SoftTypography
                              variant="button"
                              fontWeight="medium"
                              sx={{
                                fontSize: "0.75rem",
                                color:
                                  user.approved_leave_days_this_year === 0
                                    ? "#f44336"
                                    : "#4caf50",
                              }}
                            >
                              {user.approved_leave_days_this_year} Days Used
                            </SoftTypography>
                          </SoftBox>

                          {user.shift && (
                            <SoftTypography variant="caption">
                              Shift: {user.shift.start_time} - {user.shift.end_time}
                            </SoftTypography>
                          )}
                        </Card>
                      </Col>
                    ))}
                </Row>
              )}
            </SoftBox>
          </SoftBox>

          {/* PAGINATION */}
          {/* <SoftPagination variant="gradient" color="info">
            <SoftBox
              sx={{
                position: "fixed",
                width: "90%",
                bottom: 0,
                background: "#fff",
                pt: 1,
                zIndex: 20,
                borderTop: "1px solid #e0e0e0",
                display: "flex",
                justifyContent: "center",
              }}
            >
              { <Pagination count={totalPages} page={page} onChange={(_, value) => setPage(value)} /> }
            </SoftBox>
          </SoftPagination> */ }
          <SoftPagination variant="gradient" color="info">
            <SoftBox
              sx={{
                position: "fixed",
                width: "90%",
                bottom: 0,
                background: "#fff",
                pt: 1,
                zIndex: 20,
                borderTop: "1px solid #e0e0e0",
                display: "flex",
                justifyContent: "center",
                gap: 0.5,
              }}
            >

              {/* FIRST */}
              <SoftPagination
                item
                disabled={page === 1}
                onClick={() => {
                  setPage(1);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                «
              </SoftPagination>

              {/* PREV */}
              <SoftPagination
                item
                disabled={page === 1}
                onClick={() => {
                  setPage(page - 1);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                ‹
              </SoftPagination>

              {/* PAGE NUMBERS */}
              {getPaginationRange().map((item, i) => {
                if (item === "...") {
                  return (
                    <SoftPagination key={i} item disabled>
                      ...
                    </SoftPagination>
                  );
                }

                return (
                  <SoftPagination
                    key={i}
                    item
                    active={page === item}
                    onClick={() => {
                      setPage(item);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    {item}
                  </SoftPagination>
                );
              })}

              {/* NEXT */}
              <SoftPagination
                item
                disabled={page === totalPages}
                onClick={() => {
                  setPage(page + 1);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                ›
              </SoftPagination>

              {/* LAST */}
              <SoftPagination
                item
                disabled={page === totalPages}
                onClick={() => {
                  setPage(totalPages);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                »
              </SoftPagination>

            </SoftBox>
          </SoftPagination>
        </Card>
      ) : (
        <>
          {/* BACK HEADER */}
          <SoftBox display="flex" alignItems="center" mt={-1.5} mb={0} gap={1.5}>
            <IconButton onClick={() => setSelectedUser(null)} size="small">
              <ArrowBack fontSize="small" />
            </IconButton>

            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: "50%",
                bgcolor: "#EEF2FF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid #E0E7FF",
              }}
            >
              <Person sx={{ fontSize: 18 }} />
            </Box>

            <SoftTypography variant="h6" color="text">
              {selectedUser?.name} {selectedUser?.last_name}
            </SoftTypography>
          </SoftBox>

          {/* TABS */}
          <Tabs value={activeDataTab} onChange={(_, v) => setActiveDataTab(v)}>
            {["Leave Summary", "Leave Balance", "My Request"].map((tab) => (
              <Tab
                key={tab}
                value={tab}
                label={
                  <SoftTypography fontSize="0.875rem" fontWeight="medium" color="text">
                    {tab}
                  </SoftTypography>
                }
              />
            ))}
          </Tabs>

          {/* TAB CONTENT */}
          {activeDataTab === "Leave Summary" && (
            <Box sx={{ mt: 2 }}>
              <LeaveSummaryTab userId={selectedUser.id} />
            </Box>
          )}
          {activeDataTab === "Leave Balance" && (
            <Box sx={{ mt: 1.5 }}>
              <LeavaBalance userId={selectedUser.id} />
            </Box>
          )}
          {activeDataTab === "My Request" && (
            <Box sx={{ mt: 1.5 }}>
              <MyLeaveRequest userId={selectedUser.id} />
            </Box>
          )}
        </>
      )}
    </SoftBox>
  );
};

export default LeaveTeamList;
